<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold;">Mantenimiento de proveedores</label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
    tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>


<div class="row">

  <!-- <div class="col-md-12"> -->
  <div class="col-lg-12">
    <br>

    <div [hidden]="vista !== 1">
      <button type="button" style="margin-left: 10px;" class="btn btn-rounded btn-success m-b-5"
        (click)="verInsertar()"><i class="fa fa-plus"></i> Nuevo </button>
    </div>

    <!-- <div [hidden]="vista !== 2">
      <button type="button" class="btn btn-rounded btn-info m-b-15"
        (click)="guardarPlanCuenta(vista === 2 ? 'nuevo' : 'modificar')" tabindex="13"><i class="fa fa-save"></i>
        Guardar </button>
      <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()"
        (keydown.tab)="onNexFocus(vista === 2 ? 'nuevo' : 'modificar')" tabindex="14"><i class="fa fa-times-circle"></i>
        Cancelar </button>
    </div> -->
    <!--
    <div [hidden]="vista !== 3">
      <button type="button" class="btn btn-rounded btn-info m-b-15"
        (click)="guardarPlanCuenta('modificar')" tabindex="28"><i class="fa fa-save"></i>
        Guardar
      </button>
      <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()"
        (keydown.tab)="onNexFocus(vista === 3 ? 'nuevo' : 'modificar')" tabindex="29"><i class="fa fa-times-circle"></i>
        Cancelar </button>
    </div> -->


    <div class="card">
      <div class="card-body">
        <div [hidden]="vista !== 1">
          <div>
            <!--  <h4 class="card-title">Plan cuentas:</h4> -->
            <!-- <div class="card-header card-header-modific">
            <div class="row">
                <label class="col-form-label" style="font-weight: bold;">Mantenimiento de proveedores</label>
            </div>
           </div> -->
            <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
              <!-- <label for="fname2" class="col-md-2 text-left control-label col-form-label">Destino:
                  </label> -->

              <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Proveedor:</label>

              <div class="col-sm-2">
                <input type="text" class="focus-input input_border form-control tsiInput mr-2" name="desInterlocutor"
                  [(ngModel)]="buscar_codcli" tabindex="5" (keydown.enter)="onKeyEnterInterlocutorCodigo($event)">
              </div>
              <div class="input-group col-md-8">

                <input type="text" class="focus-input input_border form-control  col-md-11 tsiInput"
                  name="codInterlocutor" [(ngModel)]="buscar_razonc" tabindex="6" #interlocutor
                  (keydown.enter)="onKeyEnterInterlocutor($event)">

                <div class="input-group-append " style="width:40px">
                  <button *ngIf="buscarLimpiarBoton == 'buscar' " class="btn btn-primary btn-sm boton "
                    (click)="openModalInterlocutor()" type="button" tabindex="7"
                    ><i class="fa fa-search"></i></button>
                  <button *ngIf="buscarLimpiarBoton == 'borrar'" class="btn btn-primary btn-sm boton "
                    (click)="borrarDatosInterlocutor()" type="button" tabindex="7"
                    ><i class="fas fa-times"></i></button>
                </div>
              </div>

            </div>

          

            <div class="table-responsive" style="height:60vh;">
              <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                <thead>
                  <tr>
                    <th style="text-align: left;"></th>
                    <th style="text-align: left;"> Código </th>
                    <th style="text-align: left;"> Descripción </th>
                    <th style="text-align: left;"> Activo </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let lst of proveedores" (click)="onClick(lst)"
                    [ngClass]="{'nombre-de-la-clase': lst == this.itemtemp}">

                    <td scope="row" style="display: table-cell; text-align: center; padding-bottom: 0px;">
                      <div class="btn-group btn-group-xs" role="group" style="margin: 0px;padding: 0px;"><button
                          type="button" class="btn btn-sm" (click)="abrirModificar(lst) " style="border: none; outline: none;" ><span class="fas fa-pencil-alt"
                            aria-hidden="true"></span></button>
                      </div>
                    </td>
                    <td>{{lst.codpro}}</td>
                    <td style="text-align: left;">{{lst.razonc}}</td>
               
                    <td>
                      <div style="text-align: center" *ngIf="lst.codcla01 == '1'">
                        <i class="fas fa-check fa-lg" style="color: green;"></i>
                      </div>
                      <div style="text-align: center;" *ngIf="lst.codcla01 != '1'">
                        <i class="fas fa-times fa-lg" style="color: red;"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>


        <!-- <div [hidden]="vista != 3">
          <div>
            <ngb-tabset>

              <ngb-tab title="Datos plan de cuenta">
                <ng-template ngbTabContent>
                  <div>
                    <hr>


                    <div class="row">

                      <div class="col-md-12" style="padding-right: 15px !important;">
                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="codCuenta" class="col-md-3 text-left control-label col-form-label">Cuenta:
                          </label>
                          <div class="col-sm-4">
                            <input disabled type="text" class="form-control form-control-sm text-left"
                              [(ngModel)]="objPlanCuenta.cuenta" name="codCuenta" maxlength="16" #codCuenta
                              onkeypress='return event.charCode >= 8 && event.charCode <= 57' placeholder="Cuenta">
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>


                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="descripcion" class="col-md-3 text-left control-label col-form-label">Descripción:
                          </label>
                          <div class="col-sm-8">
                            <input type="text" class="form-control form-control-sm text-left" #desVenModificar
                              [(ngModel)]="objPlanCuenta.nombre" name="descripcion" maxlength="45" tabindex="1"
                               placeholder="Decripción">
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="descripcion" class="col-md-3 text-left control-label col-form-label">Validez
                            desde:
                          </label>
                          <div class="col-sm-8">
                            <input class="form-control form-control-sm text-left" [(ngModel)]="objPlanCuenta.fhabdes"
                              name="fhabdes" tabindex="2" type="date" max="2999-01-01"
                              style="text-align: center !important; width: 130px !important;">
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="descripcion" class="col-md-3 text-left control-label col-form-label">Validez
                            hasta:
                          </label>
                          <div class="col-sm-8">
                            <input class="form-control form-control-sm text-left" [(ngModel)]="objPlanCuenta.fhabhas"
                              name="fhabhas" tabindex="3" type="date" max="2999-01-01"
                              style="text-align: center !important; width: 130px !important;">
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="inputdebehaber"
                            class="col-md-3 text-left control-label col-form-label">Debe/Haber:
                          </label>
                          <div class="col-sm-2">
                            <input type="text" class="form-control form-control-sm " [(ngModel)]="objPlanCuenta.dh"
                              name="inputdebehaber" maxlength="1" tabindex="4" style="text-align: center !important;"
                              (keydown.enter)="onKeyEnterDebeHaber($event)" (blur)="onBlurModuloDebeHaber($event)" #dh>
                          </div>
                          <div class="col-sm-3">

                            <select id="selectdebehaber" tabindex="5" class="form-control form-control-sm select_border" name="selectdebehaber"
                              [(ngModel)]="objPlanCuenta.dh" style="margin-bottom: 12px !important ;">
                              <option value='D'>Debe</option>
                              <option value='H'>Haber</option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>


                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="selectNivel" class="col-md-3 text-left control-label col-form-label">Nivel:
                          </label>

                          <div class="col-sm-3">
                            <select tabindex="6"  class="custom-select" class="form-control form-control-sm select_border" name="selectNivel"
                              [(ngModel)]="objPlanCuenta.nivel" style="margin-bottom: 12px !important ;">
                              <option value=0>Sin Nivel</option>
                              <option value=1>Nivel 1</option>
                              <option value=2>Nivel 2</option>
                              <option value=3>Nivel 3</option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif;">(*)</span>
                        </div>


                        <div class="form-group row">
                          <label for="moneda01" class=" col-md-3 text-left control-label col-form-label">Moneda 01:
                          </label>
                          <div class="col-sm-2">
                            <input tabindex="7" style="text-align: center;"
                              class="form-control form-control-sm text-left" [(ngModel)]="objPlanCuenta.moneda01"
                              name="codsucInsert" type="text" maxlength="3">
                          </div>
                          <div class="col-md-3">
                            <select  tabindex="8" class="form-control form-control-sm select_border" [(ngModel)]="objPlanCuenta.moneda01"
                              name="moneda01">
                              <option *ngFor="let mon of monedas" [value]="mon.codmon">
                                {{mon.desmon}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="moneda02" class=" col-md-3 text-left control-label col-form-label">Moneda 02:
                          </label>
                          <div class="col-sm-2">
                            <input tabindex="9" style="text-align: center;"
                              class="form-control form-control-sm text-left" [(ngModel)]="objPlanCuenta.moneda02"
                              name="codsucInsert" type="text" maxlength="3">
                          </div>
                          <div class="col-md-3">
                            <select tabindex="10" class="form-control form-control-sm select_border" [(ngModel)]="objPlanCuenta.moneda02"
                              name="moneda02">
                              <option *ngFor="let mon of monedas" [value]="mon.codmon">
                                {{mon.desmon}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="analitica" class=" col-md-3 text-left control-label col-form-label">Análitica:
                          </label>
                          <div class="col-sm-2">
                            <input tabindex="11" style="text-align: center;"
                              class="form-control form-control-sm text-left" [(ngModel)]="objPlanCuenta.codtana"
                              name="inputanalitica" type="text"
                              onkeypress='return event.charCode >= 8 && event.charCode <= 57'
                              (keydown.enter)="onKeyEnterAnalitica($event)" (blur)="onBlurModuloAnalitica($event)"
                              #analitica style="text-align: center !important;">
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="12" id="selectanalitica" class="form-control form-control-sm select_border"
                              [(ngModel)]="objPlanCuenta.codtana" name="analitica">
                              <option *ngFor="let tipa of tipoanalisis" [value]="tipa.codtana">
                                {{tipa.descri}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <div class="col-sm-5" style="margin-left: 2em; margin-bottom: -13px;
                              background-color: ghostwhite">
                            <input type="checkbox" class="form-check-input" id="destino"
                              [(ngModel)]="objPlanCuenta.destino" name="destino"
                              (change)="onChangeInputCheckbox($event.target.value)">
                            <label class="form-check-label" for="destino">Destino automático</label>
                          </div>

                        </div>
                        <div class="form-group row" style="margin-bottom: 0px;     border-style: groove;
                            border-color: ghostwhite;
                            padding: 1px;
                            padding-top: 22px;
                            background-color: ghostwhite">
                          <div class="col-sm-12">
                            <div class="form-group row">
                              <label for="destid" style="padding: 0.2em 0em 0em .5em; padding-left: 20px;"
                                class=" col-sm-3 control-label col-form-label ">Debe:
                              </label>
                              <div class="col-sm-2">
                                <input [disabled]="desainputdebe" class="form-control form-control-sm" id="destid"
                                  name="destid" (keydown.enter)="onKeyEnterCodDestino($event)"
                                  [(ngModel)]="objPlanCuenta.destid" type="text" max="12" min="0">
                              </div>
                              <div class="col-sm-5">
                                <input [disabled]="desainputdebe" class="form-control form-control-sm select_border" id="destid"
                                  name="destid" (keydown.enter)="openModalPlanCuenta(1)" [(ngModel)]="descdebe">
                              </div>
                              <div class="col-sm-1">
                                <button [disabled]="deshabilitarboton" *ngIf="buscarDestino == 'buscar' "
                                  class="btn btn-primary boton m-b-5" (click)="openModalPlanCuenta(1)" type="button"
                                  style="margin-left: -20px !important;  height: 28px !important; width: 28px !important;"><i
                                    class="fa fa-search"></i></button>
                                <button [disabled]="deshabilitarboton" *ngIf="buscarDestino == 'borrar'"
                                  class="btn btn-primary boton m-b-5" (click)="borrarDatosDestino()" type="button"
                                  style="margin-left: -20px !important;  height: 28px !important; width: 28px !important;"><i
                                    class="fas fa-times"></i></button>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label for="destih" style="padding: 0.2em 0em 0em .5em; padding-left: 20px;"
                                class=" col-sm-3 control-label col-form-label">Haber:
                              </label>
                              <div class="col-sm-2">
                                <input [disabled]="desainputhaber" class="form-control form-control-sm" id="destih"
                                  name="destih" [(ngModel)]="objPlanCuenta.destih" type="text" max="12" min="0"
                                  (keydown.enter)="onKeyEnterCodDestino2($event)">
                              </div>
                              <div class="col-sm-5">
                                <input [disabled]="desainputhaber" class="form-control form-control-sm select_border" id="destih"
                                  name="destih" [(ngModel)]="deschaber" (keydown.enter)="openModalPlanCuenta(2)">
                              </div>
                              <div class="col-sm-1">
                                <button [disabled]="deshabilitarboton" *ngIf="buscarDestino2 == 'buscar' "
                                  class="btn btn-primary boton m-b-5" (click)="openModalPlanCuenta(2)" type="button"
                                  style="margin-left: -20px !important; height: 28px !important; width: 28px !important;"><i
                                    class="fa fa-search"></i></button>
                                <button [disabled]="deshabilitarboton" *ngIf="buscarDestino2 == 'borrar'"
                                  class="btn btn-primary boton m-b-5" (click)="borrarDatosDestino2()" type="button"
                                  style="margin-left: -20px !important; height: 28px !important; width: 28px !important;"><i
                                    class="fas fa-times"></i></button>
                              </div>

                            </div>

                          </div>



                        </div>

                      </div>
                      <br>
                      <div class="col-md-12" style="padding-right: 15px !important; ">
                        <br>
                        <div class="form-group row" style="margin-bottom: 0px;">
                          <div class="col-sm-5" style="margin-left: 2em;">
                            <input tabindex="13"  type="checkbox" class="form-check-input" id="imputable"
                              [(ngModel)]="objPlanCuenta.imputa" name="imputable">
                            <label class="form-check-label" for="imputable">Imputable</label>
                          </div>
                          <div class="col-sm-5" style="margin-left: 2em;">
                            <input tabindex="14"  type="checkbox" class="form-check-input" id="referencia"
                              [(ngModel)]="objPlanCuenta.refere" name="referencia">
                            <label class="form-check-label" for="referencia">Pedir Referencia</label>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <div class="col-sm-5" style="margin-left: 2em;">
                            <input tabindex="15"  (change)="onChangeInputCentroC($event.target.value)"  type="checkbox" class="form-check-input" id="ccosto"
                              [(ngModel)]="objPlanCuenta.ccosto" name="ccosto">
                            <label class="form-check-label" for="ccosto">Pedir Centro de Costos</label>
                          </div>
                          <div class="col-sm-5" style="margin-left: 2em;">
                            <input tabindex="16"  type="checkbox" class="form-check-input" id="balance"
                              [(ngModel)]="objPlanCuenta.balance" name="balance">
                            <label class="form-check-label" for="balance">Incluir en el Balance</label>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <div class="col-sm-5" style="margin-left: 2em;">
                            <input tabindex="17"  type="checkbox" class="form-check-input" id="proyec"
                              [(ngModel)]="objPlanCuenta.proyec" name="proyec">
                            <label class="form-check-label" for="proyec">Pedir Proyecto</label>
                          </div>
                          <div class="col-sm-5" style="margin-left: 2em;">
                            <input tabindex="18"  type="checkbox" class="form-check-input" id="concilia"
                              [(ngModel)]="objPlanCuenta.concilia" name="concilia">
                            <label class="form-check-label" for="concilia">Conciliación</label>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="fname2" class="col-md-6 text-left control-label col-form-label">Documento Origen:
                          </label>

                        </div>

                        <div lass="form-group row" style="margin-bottom: 0px;">
                          <div class="col-sm-4">
                            <select tabindex="19" class="form-control form-control-sm select_border" name="selectDocuOrigen"
                              [(ngModel)]="objPlanCuenta.docori" style="margin-bottom: 12px !important ;">
                              <option value=0>Ninguno</option>
                              <option value=1>Clientes</option>
                              <option value=2>Proveedor</option>
                              <option value=3>Empleado</option>
                              <option value=4>Obrero</option>
                              <option value=5>Otros</option>
                              <option value=6>Cta. Bancos</option>
                            </select>

                          </div>

                        </div>

                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="fname2" class="col-md-6 text-left control-label col-form-label">Tipo de gasto:
                          </label>
                        </div>


                        <div class="form-group row">

                          <div class="col-sm-2">
                            <input tabindex="21" style="text-align: center;"
                              class="form-control form-control-sm text-left" [(ngModel)]="objPlanCuenta.tipgas"
                              name="inputtipgas" type="text" #TipoGasto (keydown.enter)="onKeyEnterTipoGasto($event)"
                              (blur)="onBlurModuloTipoGasto($event)" style="text-align: center !important;">
                          </div>
                          <div class="col-sm-8">
                            <select tabindex="22" id="selectTipoGasto" class="form-control form-control-sm select_border"
                              [(ngModel)]="objPlanCuenta.tipgas" name="tipgas">
                              <option *ngFor="let tipg of tipogastos" [value]="tipg.codigo">
                                {{tipg.descri}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="regvencol" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-sm-6 control-label col-form-label ">Columna del registro de ventas:
                          </label>

                        </div>

                        <div class="form-group row">

                          <div class="col-sm-2">
                            <input tabindex="23" class="form-control form-control-sm" id="regvencol" name="regvencol"
                              type="number" [(ngModel)]="objPlanCuenta.regvencol" min="0" #regvencol
                              (keydown.enter)="onKeyEnterregvencol($event)" (blur)="onBlurModuloregvencol($event)">
                          </div>

                          <div class="col-sm-8">
                            <select tabindex="24" id="selectregvencol" class="form-control form-control-sm select_border"
                              [(ngModel)]="objPlanCuenta.regvencol" name="regvencol">
                              <option *ngFor="let mon of obtener_colummna_compras" [value]="mon.codigo">
                                {{mon.descri}}
                              </option>
                            </select>
                          </div>


                        </div>
                        <div class="form-group row">
                          <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-sm-6 control-label col-form-label ">Columna del registro de compras:
                          </label>

                        </div>
                        <div class="form-group row">

                          <div class="col-sm-2">
                            <input tabindex="25" style="text-align: center;" class="form-control form-control-sm text-left"
                              [(ngModel)]="objPlanCuenta.regcomcol" name="regcomcol" type="text"
                              (keydown.enter)="onKeyEnterregcomcol($event)" (blur)="onBlurModuloregcomcol($event)"
                              #regcomcol>
                          </div>
                          <div class="col-sm-8">
                            <select tabindex="26" id="selectregcomcol" class="form-control form-control-sm select_border"
                              [(ngModel)]="objPlanCuenta.regcomcol" name="regcomcol">
                              <option *ngFor="let mon of obtener_colummna_compras" [value]="mon.codigo">
                                {{mon.descri}}
                              </option>
                            </select>
                          </div>


                        </div>


                        <div class="form-group row" style="margin-bottom: 0px;">
                          <label for="selectbalance" class="col-md-6 text-left control-label col-form-label">Columna de balance:
                          </label>

                        </div>

                        <div lass="form-group row" style="margin-bottom: 0px;">
                          <div class="col-sm-5">
                            <select tabindex="27" class="form-control form-control-sm select_border" name="selectbalance"
                              [(ngModel)]="objPlanCuenta.balancecol" style="margin-bottom: 12px !important ;">
                              <option value='I'>Inventario</option>
                              <option value='N'>Naturaleza</option>
                              <option value='F'>Función</option>
                              <option value='R'>Naturaleza y función</option>
                              <option value='S'>Saldos</option>
                            </select>


                          </div>

                        </div>


                      </div>


                    </div>


                  </div>
                </ng-template>
              </ngb-tab>

              <ngb-tab>
                <ng-template ngbTabTitle><b>Clases</b></ng-template>
                <ng-template ngbTabContent>
                  <br>
                  <button type="button" class="btn btn-rounded btn-success m-b-15"
                    (click)="openNuevaClase(modNuevaClase)"><i class="fa fa-plus"></i> Nuevo </button>

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Clase</th>
                          <th>Nombre</th>
                          <th style="text-align: center;">Activo</th>
                          <th style="text-align: center;">Código</th>
                          <th style="text-align: center;">V. Real</th>
                          <th style="text-align: center;">V. Vstrg</th>
                          <th style="text-align: center;">V. Vchar</th>
                          <th style="text-align: center;">V. Time </th>
                          <th style="text-align: center;">V. Fecha</th>
                          <th style="text-align: center;">V. Entero</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of clases">
                          <td scope="row" style="display: table-cell; text-align: center; padding-bottom: 0px;">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px;padding: 0px;"><button
                                type="button" class="btn btn-sm" (click)="openModClase(modEditarClase , item)"><span
                                  class="fas fa-pencil-alt" aria-hidden="true"></span></button>
                              <button type="button" class="btn btn-sm " (click)="eliminarClase(item)"><span
                                  class="fas fa-trash-alt" aria-hidden="true"></span></button>
                            </div>
                          </td>
                          <td>{{item.clase }}</td>
                          <td>{{item.claseDesc}}</td>
                          <td>
                            <div style="text-align: center;" *ngIf="item.swflag == true"> <i class="fas fa-check fa-lg"
                                style="color: green;"></i></div>
                          </td>
                          <td style="text-align: right;">{{item.codigo }} </td>
                          <td style="text-align: right;">{{item.vreal }} </td>
                          <td style="text-align: right;">{{item.vstrg }} </td>
                          <td style="text-align: right;">{{item.vchar }} </td>
                          <td style="text-align: right;">{{item.vtime | date:'dd/MM/yyyy'}} </td>
                          <td style="text-align: right;">{{item.vdate }} </td>
                          <td style="text-align: right;">{{item.ventero }} </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-tab>

              <ngb-tab>
                <ng-template ngbTabTitle><b>Cuenta alternativa</b></ng-template>
                <ng-template ngbTabContent>
                  <br>
                  <button type="button" class="btn btn-rounded btn-success m-b-15"
                    (click)="openNuevoLibroContable(modalnuevaclase)"><i class="fa fa-plus"></i> Nuevo </button>

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Clase</th>
                          <th>Descripción</th>
                          <th>Código</th>
                          <th>Descripción</th>
                          <th style="text-align: right;">Orden</th>

                          <th style="text-align: right;">V. real</th>
                          <th style="text-align: right;">V. Cadena</th>
                          <th style="text-align: right;">V. Cararcter</th>
                          <th style="text-align: right;">V. Tiempo</th>
                          <th style="text-align: right;">V. Fecha</th>
                          <th style="text-align: right;">V. Entero</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of cuentasAlternativas">
                          <td scope="row" style="display: table-cell; text-align: center; padding-bottom: 0px;">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px;padding: 0px;"><button
                                type="button" class="btn btn-sm" (click)="open2(modalmodcuentaalter , item)"><span
                                  class="fas fa-pencil-alt" aria-hidden="true"></span></button>
                              <button type="button" class="btn btn-sm " (click)="eliminarMeta(item)"><span
                                  class="fas fa-trash-alt" aria-hidden="true"></span></button>
                            </div>
                          </td>
                          <td>{{item.clase }}</td>
                          <td>{{item.claseDesc}}</td>

                          <td style="text-align: right;">{{item.codigo }}
                          </td>
                          <td style="text-align: right;">{{item.descodigo }}
                          </td>
                          <td style="text-align: right;">{{item.orden }}
                          </td>
                          <td style="text-align: right;">{{item.vreal }}
                          </td>
                          <td style="text-align: right;">{{item.vstrg }}
                          </td>
                          <td style="text-align: right;">{{item.vchar }}
                          </td>
                          <td style="text-align: right;">{{item.vtime }}
                          </td>
                          <td style="text-align: right;">{{item.vdate }}
                          </td>

                          <td style="text-align: right;">{{item.ventero }}
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-tab>

            </ngb-tabset>

            <ng-template #modalnuevaclase let-modal>

              <div class="modal-dialog modal-lg">
                <div class="modal-content" style="width: 650px !important;">
                  <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">Nueva Cuenta Alternativa:</h4>
                    <button tabindex="1" type="button" class="close" aria-label="Close"
                      (click)="modal.dismiss('Cross click')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group row">
                              <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Cuenta Alternativa:
                              </label>


                              <div class="col-sm-2">
                                <input tabindex="2" style="text-align: center;" maxlength="4"
                                  class="form-control form-control-sm text-left"
                                  [(ngModel)]="objcuentaalternativa.clase" name="selecclasealternativa" type="text">
                              </div>
                              <div class="col-md-4">
                                <select tabindex="3" id="selecclasealternativa" tabindex="4"
                                  class="form-control form-control-sm" [(ngModel)]="objcuentaalternativa.clase"
                                  name="selecclasealternativa"
                                  (change)="onChangeClaseAlternativa($event.target.value,objcuentaalternativa.clase)">
                                  <option *ngFor="let claseA of select_clasesalternativas" [value]="claseA.clase">
                                    {{claseA.descri}}
                                  </option>
                                </select>
                              </div>


                            </div>
                            <div class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="orden" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Orden:</label>
                              <div class="col-sm-5">
                                <input tabindex="4" style="text-align: left;" class="form-control form-control-sm"
                                  name="orden" type="text" maxlength="7"
                                  onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                  [(ngModel)]="objcuentaalternativa.orden">
                              </div>
                              <span style="color: red; font: sans-serif;">(*)</span>

                            </div>
                            <div class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="codigo" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Código:</label>
                              <div class="col-sm-5">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="codigo" type="text" [(ngModel)]="objcuentaalternativa.codigo" maxlength="7">
                              </div>

                              <span style="color: red; font: sans-serif;">(*)</span>

                            </div>
                            <div class="form-group row" style="margin-bottom: 0.5rem;">

                              <label for="descri" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Descripción Código:</label>
                              <div class="col-sm-5">
                                <input tabindex="6" style="text-align: left;" class="form-control form-control-sm"
                                  name="descri" type="text" [(ngModel)]="objcuentaalternativa.codigoDesc"
                                  maxlength="30">
                              </div>

                              <span style="color: red; font: sans-serif;">(*)</span>

                            </div>


                            <div *ngIf="disabledDecimal == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="decimal" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Real:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="decimal" type="text" [(ngModel)]="objcuentaalternativa.vreal" maxlength="50">
                              </div>
                            </div>


                            <div *ngIf="disabledTexto == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="texto" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Strg:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="texto" type="text" [(ngModel)]="objcuentaalternativa.vstrg" maxlength="50">
                              </div>
                            </div>

                            <div *ngIf="disabledCaracter == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="caracter" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Char:</label>
                              <div class="col-sm-1">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="caracter" type="text" [(ngModel)]="objcuentaalternativa.vchar" maxlength="1">
                              </div>
                            </div>

                            <div *ngIf="disabledFecha == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="fecha" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Fecha:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="fecha" type="date" [(ngModel)]="objcuentaalternativa.vdate">
                              </div>
                            </div>

                            <div *ngIf="disabledTiempo == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="tiempo" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Time:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="tiempo" type="time" [(ngModel)]="objcuentaalternativa.vtime">
                              </div>
                            </div>

                            <div *ngIf="disabledNumero == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="numero" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Entera:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="numero" type="text" [(ngModel)]="objcuentaalternativa.ventero">
                              </div>
                            </div>


                          </div>
                        </div>

                      </div>
                    </form>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardar('nuevo');"
                      tabindex="8"><i class="fa fa-save"></i> Guardar</button>
                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclass()"
                      (click)="modal.close('Save click')" tabindex="9"><i class="fa fa-times-circle"></i>
                      Cancelar</button>
                  </div>

                </div>
              </div>

            </ng-template>

            <ng-template #modalmodcuentaalter let-modal>

              <div class="modal-dialog modal-lg">
                <div class="modal-content" style="width: 650px !important;">
                  <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">Modificar Cuenta Alternativa:</h4>
                    <button tabindex="1" type="button" class="close" aria-label="Close"
                      (click)="modal.dismiss('Cross click')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group row">
                              <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Cuenta Alternativa:
                              </label>


                              <div class="col-sm-2">
                                <input disabled style="text-align: center;"
                                  class="form-control form-control-sm text-left"
                                  [(ngModel)]="objcuentaalternativa.clase" name="selecclasealternativa" type="text">
                              </div>
                              <div class="col-md-4">
                                <select disabled id="selecclasealternativa" tabindex="4"
                                  class="form-control form-control-sm" [(ngModel)]="objcuentaalternativa.clase"
                                  name="selecclasealternativa"
                                  (change)="onChangeClaseAlternativa($event.target.value,objcuentaalternativa.clase)">
                                  <option *ngFor="let claseA of select_clasesalternativas" [value]="claseA.clase">
                                    {{claseA.descri}}
                                  </option>
                                </select>
                              </div>


                            </div>
                            <div class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="orden" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Orden:</label>
                              <div class="col-sm-5">
                                <input tabindex="2" style="text-align: left;" class="form-control form-control-sm"
                                  name="orden" type="text" maxlength="30"
                                  onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                  [(ngModel)]="ordenedit">
                              </div>
                              <span style="color: red; font: sans-serif;">(*)</span>

                            </div>
                            <div class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="codigo" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Código:</label>
                              <div class="col-sm-5">
                                <input tabindex="3" style="text-align: left;" class="form-control form-control-sm"
                                  name="codigo" type="text" [(ngModel)]="codigoedit" maxlength="20">
                              </div>

                              <span style="color: red; font: sans-serif;">(*)</span>

                            </div>
                            <div class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="descri" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Descripción Código:</label>
                              <div class="col-sm-5">
                                <input tabindex="4" style="text-align: left;" class="form-control form-control-sm"
                                  name="descri" type="text" [(ngModel)]="codigoDescedit" maxlength="50">
                              </div>

                              <span style="color: red; font: sans-serif;">(*)</span>

                            </div>


                            <div *ngIf="disabledDecimal == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="decimal" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Real:</label>
                              <div class="col-sm-5">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="decimal" type="text" [(ngModel)]="vrealedit" maxlength="50">
                              </div>
                            </div>


                            <div *ngIf="disabledTexto == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="texto" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Strg:</label>
                              <div class="col-sm-5">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="texto" type="text" [(ngModel)]="vstrgedit" maxlength="50">
                              </div>
                            </div>

                            <div *ngIf="disabledCaracter == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="caracter" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Char:</label>
                              <div class="col-sm-1">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="caracter" type="text" [(ngModel)]="vcharedit" maxlength="1">
                              </div>
                            </div>

                            <div *ngIf="disabledFecha == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="fecha" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Date:</label>
                              <div class="col-sm-5">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="fecha" type="date" [(ngModel)]="vdateedit">
                              </div>
                            </div>

                            <div *ngIf="disabledTiempo == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="tiempo" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Time:</label>
                              <div class="col-sm-5">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="tiempo" type="time" [(ngModel)]="vtimeedit">
                              </div>
                            </div>

                            <div *ngIf="disabledNumero == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="numero" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. Entero:</label>
                              <div class="col-sm-5">
                                <input tabindex="5" style="text-align: left;" class="form-control form-control-sm"
                                  name="numero" type="text" [(ngModel)]="venteroedit">
                              </div>
                            </div>


                          </div>
                        </div>

                      </div>
                    </form>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarmod('nuevo');"
                      tabindex="6"><i class="fa fa-save"></i> Guardar</button>
                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclass()"
                      (click)="modal.close('Save click')" tabindex="7"><i class="fa fa-times-circle"></i>
                      Cancelar</button>
                  </div>

                </div>
              </div>

            </ng-template>

            <ng-template #modNuevaClase let-modal>

              <div class="modal-dialog modal-lg">
                <div class="modal-content" style="width: 650px !important;">
                  <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">Nueva clase:</h4>
                    <button tabindex="1" type="button" class="close" aria-label="Close"
                      (click)="modal.dismiss('Cross click')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group row">
                              <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Clase:
                              </label>
                              <div class="col-sm-2">
                                <input tabindex="2" style="text-align: center;"
                                  class="form-control form-control-sm text-left" [(ngModel)]="objPClase.clase"
                                  name="selecclasealternativa" type="text">
                              </div>
                              <div class="col-md-4">
                                <select tabindex="3" id="selecclasealternativa" tabindex="4"
                                  class="form-control form-control-sm" [(ngModel)]="objPClase.clase"
                                  name="selecclasealternativa"
                                  (change)="onChangeCodigo($event.target.value,objPClase.clase)">
                                  <option *ngFor="let claseA of selectClases" [value]="claseA.clase">
                                    {{claseA.descri}}
                                  </option>
                                </select>
                              </div>
                              <div class="col-sm-2" style="margin-left: 1.5em;">
                                <input type="checkbox" class="form-check-input" id="exampleCheck2"
                                  [(ngModel)]="objPClase.swflag" name="activo" tabindex="2">
                                <label class="form-check-label" for="exampleCheck1">Activo</label>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Codigo:
                              </label>
                              <div class="col-sm-2">
                                <input tabindex="2" style="text-align: center;"
                                  class="form-control form-control-sm text-left" [(ngModel)]="objPClase.codigo"
                                  name="selecclasscodigo" type="text">
                              </div>
                              <div class="col-md-4">
                                <select tabindex="3" id="selecclasscodigo" tabindex="4"
                                  class="form-control form-control-sm" [(ngModel)]="objPClase.codigo"
                                  name="selecclasscodigo"
                                  (change)="onChangeInput($event.target.value,objcuentaalternativa.clase)">
                                  <option *ngFor="let codigo of selectClasesCodigos" [value]="codigo.codigo">
                                    {{codigo.descri}}
                                  </option>
                                </select>
                              </div>
                            </div>




                            <div *ngIf="disabledDecimal == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="decimal" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. real:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="decimal" type="text" [(ngModel)]="objPClase.vreal" maxlength="50">
                              </div>
                            </div>


                            <div *ngIf="disabledTexto == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="texto" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">v. strg:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="texto" type="text" [(ngModel)]="objPClase.vstrg" maxlength="50">
                              </div>
                            </div>

                            <div *ngIf="disabledCaracter == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="caracter" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. char:</label>
                              <div class="col-sm-1">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="caracter" type="text" [(ngModel)]="objPClase.vchar" maxlength="1">
                              </div>
                            </div>

                            <div *ngIf="disabledFecha == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="fecha" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. date:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="fecha" type="date" [(ngModel)]="objPClase.vdate">
                              </div>
                            </div>

                            <div *ngIf="disabledTiempo == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="tiempo" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. time:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="tiempo" type="time" [(ngModel)]="objPClase.vtime">
                              </div>
                            </div>

                            <div *ngIf="disabledNumero == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="numero" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. entero:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="numero" type="text" [(ngModel)]="objPClase.ventero">
                              </div>
                            </div>


                          </div>
                        </div>

                      </div>
                    </form>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarClase('nuevo');"
                      tabindex="8"><i class="fa fa-save"></i> Guardar</button>
                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertClase()"
                      (click)="modal.close('Save click')" tabindex="9"><i class="fa fa-times-circle"></i>
                      Cancelar</button>
                  </div>

                </div>
              </div>

            </ng-template>

            <ng-template #modEditarClase let-modal>

              <div class="modal-dialog modal-lg">
                <div class="modal-content" style="width: 650px !important;">
                  <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">Modificar clase:</h4>
                    <button tabindex="1" type="button" class="close" aria-label="Close"
                      (click)="modal.dismiss('Cross click')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-12">

                            <div class="form-group row">
                              <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Clase:
                              </label>
                              <div class="col-sm-2">
                                <input disabled tabindex="2" style="text-align: center;"
                                  class="form-control form-control-sm text-left" [(ngModel)]="objPClase.clase"
                                  name="selecclasealternativa" type="text">
                              </div>
                              <div class="col-md-4">
                                <select disabled tabindex="3" id="selecclasealternativa" tabindex="4"
                                  class="form-control form-control-sm" [(ngModel)]="objPClase.clase"
                                  name="selecclasealternativa"
                                  (change)="onChangeCodigo($event.target.value,objPClase.clase)">
                                  <option *ngFor="let claseA of selectClases" [value]="claseA.clase">
                                    {{claseA.descri}}
                                  </option>
                                </select>
                              </div>
                              <div class="col-sm-2" style="margin-left: 1.5em;">
                                <input type="checkbox" class="form-check-input" id="exampleCheck2"
                                  [(ngModel)]="swflagedit" name="activo" tabindex="2">
                                <label class="form-check-label" for="exampleCheck1">Activo</label>
                              </div>
                            </div>

                            <div class="form-group row">
                              <label for="regcomcol" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">Codigo:
                              </label>
                              <div class="col-sm-2">
                                <input tabindex="2" style="text-align: center;"
                                  class="form-control form-control-sm text-left" [(ngModel)]="codigoEdit"
                                  name="selecclasscodigo" type="text">
                              </div>
                              <div class="col-md-4">
                                <select tabindex="3" id="selecclasscodigo" tabindex="4"
                                  class="form-control form-control-sm" [(ngModel)]="codigoEdit" name="selecclasscodigo"
                                  (change)="onChangeInput($event.target.value,objcuentaalternativa.clase)">
                                  <option *ngFor="let codigo of selectClasesCodigos" [value]="codigo.codigo">
                                    {{codigo.descri}}
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div *ngIf="disabledDecimal == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="decimal" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. real:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="decimal" type="text" [(ngModel)]="vrealEdit" maxlength="50">
                              </div>
                            </div>


                            <div *ngIf="disabledTexto == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="texto" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">v. strg:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="texto" type="text" [(ngModel)]="vstrgEdit" maxlength="50">
                              </div>
                            </div>

                            <div *ngIf="disabledCaracter == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="caracter" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. char:</label>
                              <div class="col-sm-1">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="caracter" type="text" [(ngModel)]="vcharEdit" maxlength="1">
                              </div>
                            </div>

                            <div *ngIf="disabledFecha == 'S' " class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="fecha" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. date:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="fecha" type="date" [(ngModel)]="vdateEdit">
                              </div>
                            </div>

                            <div *ngIf="disabledTiempo == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="tiempo" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. time:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="tiempo" type="time" [(ngModel)]="vtimeEdit">
                              </div>
                            </div>

                            <div *ngIf="disabledNumero == 'S'" class="form-group row" style="margin-bottom: 0.5rem;">
                              <label for="numero" style="padding: 0.2em 0em 0em .5em;"
                                class=" col-sm-3 control-label col-form-label ">V. entero:</label>
                              <div class="col-sm-5">
                                <input tabindex="7" style="text-align: left;" class="form-control form-control-sm"
                                  name="numero" type="text" [(ngModel)]="venteroEdit">
                              </div>
                            </div>


                          </div>
                        </div>

                      </div>
                    </form>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarmodClase('nuevo');"
                      tabindex="8"><i class="fa fa-save"></i> Guardar</button>
                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertClase()"
                      (click)="modal.close('Save click')" tabindex="9"><i class="fa fa-times-circle"></i>
                      Cancelar</button>
                  </div>

                </div>
              </div>

            </ng-template>


          </div>
        </div>  -->
      </div>
    </div>

  </div>
</div>